import { PageFlow } from '@fullstory/proto/fs/api/metrics/pagemetrics';

export interface Page
  extends Pick<PageFlow, 'count' | 'pageDefId' | 'totalIncomingCount' | 'totalOutgoingCount'> {}

// Some types that help us map the PageFlowPage interface into something the `Graph` component can use
export type PageType = 'entry' | 'exit';

// internalId is an id in the form `${pageDefId}-${type}` to better deal with cycles
export type GraphNode = Page & { x: number; y: number; type?: PageType; internalId: string };

export enum PageTypes {
  ENTRY = 'entry',
  EXIT = 'exit',
}

export type GraphLink = {
  target: GraphNode;
  source: GraphNode;
  width: number;
};

export interface Link {
  link: GraphLink;
}

export interface Node {
  node: GraphNode;
}

export interface ClickedPageFlowNodeAnalytics {
  isOtherNode: boolean;
  entryOrExit?: PageType;
  totalOther: number;
}
